import { reducer as ChatbotReducer } from '../Slice/ChatbotV2Slice';
import { reducer as HelperReducer } from '../Slice/HelperSlice';
import { reducer as UIReducer } from '../Slice/UISlice';
import { reducer as LoginReducer } from '../Slice/LoginSlice';
;
var rootReducers = {
    chatbotV2: ChatbotReducer,
    helper: HelperReducer,
    ui: UIReducer,
    login: LoginReducer,
};
export default rootReducers;
